export const isWindowsOrLinux = () => {
  const userAgent = window.navigator.userAgent;

  const isIOS =
    (/iPad|iPhone|iPod/.test(userAgent) ||
      (/Mac|Mac OS|MacIntel/gi.test(userAgent) && (navigator.maxTouchPoints > 1 || 'ontouchend' in document))) &&
    !(window as any).MSStream;

  if (/Macintosh|Mac|Mac OS|MacIntel|MacPPC|Mac68K/gi.test(userAgent)) {
    return false;
  } else if (isIOS) {
    return false;
  } else if (/'Win32|Win64|Windows|Windows NT|WinCE/gi.test(userAgent)) {
    return true;
  } else if (/Android/gi.test(userAgent)) {
    return false;
  } else if (/Linux/gi.test(userAgent)) {
    return true;
  }

  return false;
};
